// Professional Hair Color Chart Data
// Based on standard salon color levels and tones

export const hairColorLevels = [
  {
    level: 1,
    name: 'Black',
    baseColor: '#1A1A1A',
    shades: [
      { code: '1N', name: 'Natural Black', hex: '#1A1A1A' },
      { code: '1A', name: 'Ash Black', hex: '#131313' },
      { code: '1B', name: 'Blue Black', hex: '#0F0F15' },
    ]
  },
  {
    level: 2,
    name: 'Darkest Brown',
    baseColor: '#2C1810',
    shades: [
      { code: '2N', name: 'Natural Darkest Brown', hex: '#2C1810' },
      { code: '2A', name: 'Ash Darkest Brown', hex: '#261813' },
    ]
  },
  {
    level: 3,
    name: 'Dark Brown',
    baseColor: '#3B2414',
    shades: [
      { code: '3N', name: 'Natural Dark Brown', hex: '#3B2414' },
      { code: '3A', name: 'Ash Dark Brown', hex: '#362418' },
      { code: '3G', name: 'Gold Dark Brown', hex: '#3F2710' },
      { code: '3R', name: 'Red Dark Brown', hex: '#3D1C10' },
      { code: '3M', name: 'Mahogany Dark Brown', hex: '#3A1915' },
    ]
  },
  {
    level: 4,
    name: 'Medium Brown',
    baseColor: '#4A2F1A',
    shades: [
      { code: '4N', name: 'Natural Medium Brown', hex: '#4A2F1A' },
      { code: '4NN', name: 'Intense Natural Medium Brown', hex: '#4D3220' },
      { code: '4A', name: 'Ash Medium Brown', hex: '#453020' },
      { code: '4G', name: 'Gold Medium Brown', hex: '#523518' },
      { code: '4C', name: 'Copper Medium Brown', hex: '#4F2816' },
      { code: '4R', name: 'Red Medium Brown', hex: '#4C2215' },
      { code: '4RR', name: 'Intense Red Medium Brown', hex: '#4A1E12' },
      { code: '4RB', name: 'Red-Brown Medium', hex: '#4B2418' },
      { code: '4M', name: 'Mahogany Medium Brown', hex: '#482320' },
      { code: '4V', name: 'Violet Medium Brown', hex: '#432628' },
    ]
  },
  {
    level: 5,
    name: 'Light Brown',
    baseColor: '#5D3C26',
    shades: [
      { code: '5N', name: 'Natural Light Brown', hex: '#5D3C26' },
      { code: '5NN', name: 'Intense Natural Light Brown', hex: '#614028' },
      { code: '5A', name: 'Ash Light Brown', hex: '#583D2A' },
      { code: '5G', name: 'Gold Light Brown', hex: '#674520' },
      { code: '5C', name: 'Copper Light Brown', hex: '#6A3820' },
      { code: '5R', name: 'Red Light Brown', hex: '#65301E' },
      { code: '5RR', name: 'Intense Red Light Brown', hex: '#622818' },
      { code: '5RB', name: 'Red-Brown Light', hex: '#633528' },
      { code: '5RV', name: 'Red-Violet Light Brown', hex: '#5E2F30' },
      { code: '5M', name: 'Mahogany Light Brown', hex: '#5C3232' },
      { code: '5V', name: 'Violet Light Brown', hex: '#573338' },
      { code: '5B', name: 'Brown Light Brown', hex: '#5A3828' },
    ]
  },
  {
    level: 6,
    name: 'Dark Blonde',
    baseColor: '#7A5436',
    shades: [
      { code: '6N', name: 'Natural Dark Blonde', hex: '#7A5436' },
      { code: '6NN', name: 'Intense Natural Dark Blonde', hex: '#7E5838' },
      { code: '6A', name: 'Ash Dark Blonde', hex: '#75553C' },
      { code: '6G', name: 'Gold Dark Blonde', hex: '#856030' },
      { code: '6C', name: 'Copper Dark Blonde', hex: '#8A4E28' },
      { code: '6R', name: 'Red Dark Blonde', hex: '#844428' },
      { code: '6RR', name: 'Intense Red Dark Blonde', hex: '#803820' },
      { code: '6RB', name: 'Red-Brown Dark Blonde', hex: '#7D4A35' },
      { code: '6M', name: 'Mahogany Dark Blonde', hex: '#784540' },
      { code: '6V', name: 'Violet Dark Blonde', hex: '#734248' },
      { code: '6W', name: 'Warm Dark Blonde', hex: '#885A35' },
    ]
  },
  {
    level: 7,
    name: 'Medium Blonde',
    baseColor: '#996D48',
    shades: [
      { code: '7N', name: 'Natural Medium Blonde', hex: '#996D48' },
      { code: '7NN', name: 'Intense Natural Medium Blonde', hex: '#9D7050' },
      { code: '7A', name: 'Ash Medium Blonde', hex: '#947050' },
      { code: '7G', name: 'Gold Medium Blonde', hex: '#A67940' },
      { code: '7C', name: 'Copper Medium Blonde', hex: '#AC6338' },
      { code: '7R', name: 'Red Medium Blonde', hex: '#A55838' },
      { code: '7RR', name: 'Intense Red Medium Blonde', hex: '#A04830' },
      { code: '7M', name: 'Mahogany Medium Blonde', hex: '#985850' },
      { code: '7V', name: 'Violet Medium Blonde', hex: '#935A58' },
      { code: '7W', name: 'Warm Medium Blonde', hex: '#A87548' },
      { code: '7WG', name: 'Warm Gold Medium Blonde', hex: '#B07A45' },
    ]
  },
  {
    level: 8,
    name: 'Light Blonde',
    baseColor: '#B8885A',
    shades: [
      { code: '8N', name: 'Natural Light Blonde', hex: '#B8885A' },
      { code: '8NN', name: 'Intense Natural Light Blonde', hex: '#BD8D60' },
      { code: '8A', name: 'Ash Light Blonde', hex: '#B38B65' },
      { code: '8G', name: 'Gold Light Blonde', hex: '#C59450' },
      { code: '8C', name: 'Copper Light Blonde', hex: '#CC7F48' },
      { code: '8R', name: 'Red Light Blonde', hex: '#C57548' },
      { code: '8V', name: 'Violet Light Blonde', hex: '#B37568' },
      { code: '8P', name: 'Pearl Light Blonde', hex: '#BF9075' },
      { code: '8W', name: 'Warm Light Blonde', hex: '#C89060' },
    ]
  },
  {
    level: 9,
    name: 'Very Light Blonde',
    baseColor: '#D9A872',
    shades: [
      { code: '9N', name: 'Natural Very Light Blonde', hex: '#D9A872' },
      { code: '9A', name: 'Ash Very Light Blonde', hex: '#D4AB7E' },
      { code: '9G', name: 'Gold Very Light Blonde', hex: '#E5B368' },
      { code: '9P', name: 'Pearl Very Light Blonde', hex: '#E0B488' },
      { code: '9V', name: 'Violet Very Light Blonde', hex: '#D49888' },
    ]
  },
  {
    level: 10,
    name: 'Lightest Blonde / Platinum',
    baseColor: '#F5D0A0',
    shades: [
      { code: '10N', name: 'Natural Platinum', hex: '#F5D0A0' },
      { code: '10A', name: 'Ash Platinum', hex: '#F0D3AA' },
      { code: '10G', name: 'Gold Platinum', hex: '#FFD88C' },
      { code: '10P', name: 'Pearl Platinum', hex: '#FAD8B0' },
      { code: '10V', name: 'Violet Platinum', hex: '#F0C0B0' },
    ]
  },
];

export const toneDescriptions = {
  'N': { name: 'Natural', description: 'Balanced, true-to-tone color' },
  'NN': { name: 'Intense Natural', description: 'Rich, concentrated natural pigment' },
  'A': { name: 'Ash', description: 'Cool, green-based; reduces brassiness' },
  'AA': { name: 'Intense Ash', description: 'Strong cool tone for maximum brass reduction' },
  'G': { name: 'Gold', description: 'Warm, yellow-based radiance' },
  'GG': { name: 'Intense Gold', description: 'Vibrant golden warmth' },
  'C': { name: 'Copper', description: 'Warm, orange-red glow' },
  'R': { name: 'Red', description: 'Bold red pigment' },
  'RR': { name: 'Intense Red', description: 'Vivid, fashion-forward red' },
  'RB': { name: 'Red-Brown', description: 'Red with brown depth' },
  'RV': { name: 'Red-Violet', description: 'Red with violet cool tones' },
  'M': { name: 'Mahogany', description: 'Rich red-brown with depth' },
  'B': { name: 'Blue / Brown', description: 'Deep, cool brown tones' },
  'V': { name: 'Violet', description: 'Cool, purple-based; neutralizes yellow' },
  'W': { name: 'Warm', description: 'Soft, golden-beige warmth' },
  'WA': { name: 'Warm Ash', description: 'Balanced warm and cool' },
  'WG': { name: 'Warm Gold', description: 'Honey-gold warmth' },
  'P': { name: 'Pearl', description: 'Soft, iridescent shimmer' },
};